import { render, staticRenderFns } from "./SnippetVersionTimeline.vue?vue&type=template&id=2bf6258e&scoped=true&"
import script from "./SnippetVersionTimeline.vue?vue&type=script&lang=js&"
export * from "./SnippetVersionTimeline.vue?vue&type=script&lang=js&"
import style0 from "./SnippetVersionTimeline.vue?vue&type=style&index=0&id=2bf6258e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf6258e",
  null
  
)

export default component.exports